<template>
  <v-card>
    <!-- <v-card-title>VLE CMS</v-card-title> -->
    <v-tabs horizontal v-model="tab" class="pp-main" grow style="background-color: transparent">
      <v-tab key="coursesTab" color="primary">
        <v-icon class="mr-3">
          mdi-book-plus
        </v-icon>
        Manage Courses
      </v-tab>
      <v-tab key="contentTab" color="primary">
        <v-icon class="pr-3">
          mdi-play-circle-outline
        </v-icon>
        Manage Content
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" >
      <v-tab-item key="coursesTab">
        <CourseTab/>
      </v-tab-item>
      <v-tab-item key="contentTab">
        <ContentTab/>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>

import CourseTab from "./CourseTab";
import ContentTab from "./ContentTab";

export default {
  name: "MainTab",
  components: {
    ContentTab,
    CourseTab,
  },
  data() {
    return {
      tab: null,
    };
  },
};
</script>

<style scoped>
.pp-main {
  background-color: white;
  color: var(--primary);
}

</style>
